export default __webpack_public_path__ + "static/media/driver.4166420a.svg";